import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Bamboohr = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 23"
    {...props}
  >
    <g id="bamboohr_layer_1_">
      <g id="bamboohr_layer_2_">
        <g id="bamboohr_layer_3_">
          <path
            id="bamboohr_BambooHR"
            fill="hsl(from hsl(88 74% 44%) h s 51%)"
            d="M16.8,8.5c3.3,0,6.2,2.9,6.2,6.2c0,3.6-2.8,6.4-6.4,6.4c-3.3,0-6.2-2.3-6.2-6V2.9h1.9v7.4
				l0.2-0.2C13.4,9.3,14.6,8.5,16.8,8.5z M16.6,19.3c2.7,0,4.4-1.9,4.4-4.4c0-2.3-1.6-4.5-4.4-4.5c-2.8,0-4.5,2.1-4.5,4.6
				C12.2,17.4,14.2,19.3,16.6,19.3z M6.6,4.4C8,5.9,8.2,6.7,8.7,8.2L9.5,11c0,0-0.8-0.2-1.5-0.3c-0.8-0.1-1.2-0.2-2.2-0.7
				C4.8,9.6,3.9,8.6,3,7.5C2.1,6.4,0,4.7,0,4.7s0.7,0,1.3,0.2C1.8,5,3.3,5.4,4.7,6.2C5,6.4,5.2,6.5,5.5,6.7C6,6.9,6.5,7.4,7,7.9
				c0.6,0.6,1.1,1,1.5,1.6C8,8.6,6.8,5.5,4.5,3C4.2,2.8,6.1,3.9,6.6,4.4z"
          />
        </g>
      </g>
    </g>
  </svg>
);
